import instance from "..";
import { createQueryString } from "src/utils/helper";
import { setParentsList } from "src/reducers/parents";
import { dummyParents } from "src/constants/dummyParents";

// ✅ SAFE ID EXTRACTOR
const extractId = (input: any): string | null => {
  if (!input) return null;
  if (typeof input === "string") return input;
  if (typeof input === "object" && input.id) return input.id;
  return null;
};

// ✅ GET PARENTS
export const getParentsListAction: any =
  (apiData) => async (dispatch: any) => {
    try {
      const query = createQueryString(apiData);

      const res = await instance.get(`/api/v1/admin/parents?${query}`);
      const apiResponse = res?.data;

      if (
        !apiResponse?.success ||
        !apiResponse?.data ||
        !apiResponse?.data?.data
      ) {
        dispatch(setParentsList(dummyParents));
        return dummyParents;
      }

      const formattedData = {
        data: apiResponse.data.data.map((item: any) => ({
          id: item.id,
          name: item.fullName,
          email: item.email,
          phone: item.phone,
          status: item.isActive ? 1 : 0,
          createdOn: item.createdAt,

          // ✅ children 그대로 유지 (UI uses it)
          children: item.children?.map((c: any) => ({
            id: c.id,
            name: c.fullName,
            dob: c.dob,
            grade: c.grade,
            school: c.schoolName,
            emergencyContact: c.emergencyContactName,
            emergencyPhone: c.emergencyContactPhone,
          })) || [],

          // ✅ addresses mapping (IMPORTANT FIX)
          addresses: item.addresses?.map((a: any) => ({
            id: a.id,
            type: a.addressType,
            address: a.fullAddress,
            landmark: a.landmark,
            pincode: a.pincode,
            lat: a.latitude,
            lng: a.longitude,
          })) || [],
        })),
        total: apiResponse.data.total,
      };

      dispatch(setParentsList(formattedData));
      return formattedData;
    } catch (err) {
      dispatch(setParentsList(dummyParents));
      return dummyParents;
    }
  };

// ✅ TOGGLE STATUS
export const updateParentStatusAction: any =
  (input: any) => async () => {
    try {
      const id = extractId(input);
      if (!id) throw new Error("Invalid parent id");

      const res = await instance.put(
        `/api/v1/admin/users/${id}/toggle-status`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ DELETE
export const deleteParentAction: any =
  (input: any) => async () => {
    try {
      const id = extractId(input);
      if (!id) throw new Error("Invalid parent id");

      const res = await instance.delete(
        `/api/v1/admin/deleteUser/${id}`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };